import _ from "lodash";

/**
USAGE (php response data):
    return ['message' => 'Some message!',  'notify' => ['type' => 'warning']];
    return ['message' => 'Some message!',  'notify' => true;
    return ['message' => 'Some message!',  'snackbar' => ['type' => 'warning']];
    return ['message' => 'Some message!'; // returnib tavalise snackbari
 */
const snackbarDefaults = {
  timeout: 4000,
  top: true,
  fixed: true,
};

const notifyDefaults = {
  timeout: 10000,
  position: "top-right",
  type: "success",
};

const dialogDefaults = {};

const expectedServerResponse = {
  message: "Õnnestus",
};

class Notify {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor(context, response, config = {}) {
    this.config = config;
    this.context = context;
    this.message =
      typeof response === "string"
        ? response
        : _.get(response, ["data", "message"]);
        
    if (!this.message) this.message = _.get(response, ["message"]);
    if (!this.message) return;

    this.notify = _.get(response, ["data", "notify"], null);

    if (
      this.notify ||
      _.has(response, ["data", "exception"]) ||
      config.type === "error"
    ) {
      this.showNotification();
      return;
    }

    this.snackbar = _.get(response, ["data", "snackbar"], {});
    this.showSnackbar();
  }

  showNotification() {
    if (typeof this.notify !== "object" || this.notify === null)
      this.notify = {};

    const config = { ...notifyDefaults, ...this.config, ...this.notify };
    this.context.$dialog.notify[config.type](this.message, config);
  }

  showSnackbar() {
    if (typeof this.snackbar !== "object" || this.snackbar === null)
      this.snackbar = {};

    const config = {
      ...snackbarDefaults,
      ...this.config,
      ...this.snackbar,
    };
    this.context.$store.dispatch("snackbar/show", {
      content: this.message,
      props: config,
    });
  }
}

export default Notify;
